import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("df1a59bc40", "@media (min-width:600px){._77efcb9ca06f5774__modal{width:600px}}");
}
export default {"modal":"_77efcb9ca06f5774__modal"};
